import { specialChars, tryDecodeFilePath } from '@/utils/constants';
import * as Yup from 'yup';

export const FOLDER_NAME = 'folderName';
export const ERROR_MESSAGE = 'errorMessage';
export const FOLDER_NAME_MAX = 60;
export const CLIENT_NAME_MAX = 100;
export const CLAIM_NAME_MAX = 100;
export const FILE_NAME_MAX = 150;

export const folderNameSchema = ({
	title = 'Folder name',
	maxLength = FOLDER_NAME_MAX,
	maxLengthMessage = `${title} can only be a maximum of ${maxLength} characters`,
} = {}) =>
	Yup.string()
		.trim()
		.required(`${title} is required`)
		.max(maxLength, maxLengthMessage)
		.test(
			'no-special-characters',
			`${title} contains invalid characters.`,
			(value) => Boolean(value) && !specialChars.test(value.trim()),
		)
		.test(
			'no-end-in-fullstop',
			`${title} cannot end with full stop.`,
			(value) => Boolean(value) && !value.endsWith('.'),
		);

const validationSchema = (existingFolders = [], title = 'Folder name', objectType = 'deal') =>
	Yup.object().shape({
		[FOLDER_NAME]: Yup.string().when(['isProspect', 'prospect2Feature'], {
			is: (isProspect, prospect2Feature) => !isProspect || !prospect2Feature,
			then: () => {
				const maxLength =
					objectType === 'client'
						? CLIENT_NAME_MAX
						: objectType === 'claim'
							? CLAIM_NAME_MAX
							: FOLDER_NAME_MAX;
				const maxLengthMessage =
					objectType === 'client'
						? `Client name can only be a maximum of ${CLIENT_NAME_MAX} characters`
						: objectType === 'claim'
							? `Claim name can only be a maximum of ${CLAIM_NAME_MAX} characters`
							: `${title} can only be a maximum of ${maxLength} characters`;

				return folderNameSchema({ title, maxLength, maxLengthMessage }).test(
					'unique-folder',
					'A folder with this name already exists.',
					(value) => {
						if (!value) return false;
						if ((existingFolders ?? []).length === 0) return true;

						const folderExists = existingFolders.some((folder) =>
							tryDecodeFilePath(folder, value),
						);
						return !folderExists;
					},
				);
			},
			otherwise: (schema) => schema.notRequired(),
		}),
	});

export default validationSchema;
